<script setup>
import { computed, getCurrentInstance } from 'vue';
import Button from "./Button.vue";

const props = defineProps({
    id: String,
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const hiddenHelpBoxes = computed(() => {
    return store.getters['user/pref']('hiddenHelpBoxes') || [];
});

const isVisible = computed(() => {
    return (
        props.id &&
        !hiddenHelpBoxes.value.includes(props.id)
    );
});

// --- Methods ---

const remove = () => {
    // Create a new array to maintain immutability and add the current ID
    const updatedHiddenBoxes = [...hiddenHelpBoxes.value, props.id];

    store.dispatch('user/setPref', {
        name: 'hiddenHelpBoxes',
        value: updatedHiddenBoxes
    });
};
</script>

<template>
    <div v-if="isVisible" class="mb-1 p-1 border bg-light-subtle rounded position-relative">
        <Button
            class="position-absolute end-0 me-1 p-1 py-0 btn-sm"
            @click.native="remove"
        >
            ×
        </Button>

        <div class="small">
            <div class="small">
                <slot/>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Ensure the close button doesn't overlap text if the help box is very narrow */
.position-relative {
    padding-right: 2rem !important;
}
</style>